import { useJivoSite } from '@shared/hooks/useJivoSite'


export default function useFeedbackModal () {
  const { openJivoChat } = useJivoSite()

  const openFeedbackModal = () => {
    openJivoChat()
  }

  return {
    openFeedbackModal,
  }
}
